import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Send, Copy, Check } from 'lucide-react';
import { apiPost } from '../../api';

const ValidateTelegram = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null); // { linkCode, expiresAt, instructions }
  const [copied, setCopied] = useState(false);

  const generateLinkCode = async () => {
    setLoading(true);
    try {
      const res = await apiPost('/api/admin/account/telegram/generate-link-code');
      if (res.data.success) {
        setResult(res.data.data);
      } else {
        toast.error(res.data.message || 'Failed to generate link code');
      }
    } catch (e) {
      toast.error(e.response?.data?.message || 'Failed to generate link code');
    } finally {
      setLoading(false);
    }
  };

  const copyCode = () => {
    if (!result?.linkCode) return;
    navigator.clipboard?.writeText(result.linkCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const btnPrimary =
    'rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50';

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">
        Validate <span className="text-gradient-ginox">Telegram</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-6">
        Link your account with the Ginox Admin Bot on Telegram
      </p>

      <div className="border-t border-white/[0.08] pt-6">
        <div className="rounded-lg border border-border/70 bg-white/[0.02] px-4 py-3 mb-6">
          <p className="text-sm text-foreground mb-1">How to link</p>
          <p className="text-xs text-muted-foreground">
            Click the button below to generate a link code, then open the Ginox Admin Bot on
            Telegram and send the code to connect your account.
          </p>
        </div>

        <button type="button" onClick={generateLinkCode} disabled={loading} className={btnPrimary}>
          <span className="inline-flex items-center gap-2">
            <Send className="h-3.5 w-3.5" />
            {loading ? 'Generating...' : 'Validate Telegram'}
          </span>
        </button>

        {result && (
          <div className="mt-6 space-y-4">
            <div>
              <h2 className="text-[10px] font-medium uppercase tracking-[1.5px] text-muted-foreground/60 mb-1.5">
                Link Code
              </h2>
              <button
                type="button"
                onClick={copyCode}
                className="flex w-full items-center gap-2 rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-left transition-colors hover:bg-white/[0.05]"
              >
                <code className="flex-1 break-all font-mono text-lg tracking-[0.2em] text-foreground">
                  {result.linkCode}
                </code>
                {copied ? (
                  <Check className="h-4 w-4 shrink-0 text-ginox-green" />
                ) : (
                  <Copy className="h-4 w-4 shrink-0 text-muted-foreground" />
                )}
              </button>
            </div>

            {result.expiresAt && (
              <div>
                <h2 className="text-[10px] font-medium uppercase tracking-[1.5px] text-muted-foreground/60 mb-1.5">
                  Expires At
                </h2>
                <p className="text-sm text-foreground font-mono">
                  {new Date(result.expiresAt).toLocaleString()}
                </p>
              </div>
            )}

            {result.instructions && (
              <div className="rounded-lg border border-ginox-green/30 bg-ginox-green/[0.06] px-4 py-3">
                <p className="text-xs text-muted-foreground mb-1">Next step</p>
                <p className="text-sm text-foreground">{result.instructions}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidateTelegram;
